"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RepetitionTypePicker = void 0;
const lib_i18n_1 = __importDefault(require("@opsbase/lib-i18n"));
const RepetitionType_1 = __importDefault(require("@opsbase/lib-time/RepetitionType"));
const web_css_1 = __importDefault(require("@opsbase/web-css"));
const MenuItem_1 = __importDefault(require("@opsbase/web-ui/MenuItem"));
const Select_1 = __importDefault(require("@opsbase/web-ui/Select"));
const react_1 = __importStar(require("react"));
const CustomRepetitionDialog_1 = __importDefault(require("../CustomRepetitionDialog"));
const calcRepetitionLabels_1 = __importDefault(require("../helpers/calcRepetitionLabels"));
const makeMyClasses = () => ({
    selectRoot: {
        whiteSpace: 'break-spaces',
    },
    customMenu: {
        maxWidth: 430,
        whiteSpace: 'break-spaces',
        lineHeight: '22px',
    },
});
const RepetitionTypePicker = function (props) {
    const { schedule, onChange } = props;
    const [showCustom, setShowCustom] = (0, react_1.useState)(false);
    const { dueDate, customRepetition, repetitionType } = schedule;
    const isCustom = repetitionType === RepetitionType_1.default.CUSTOM;
    const myCss = (0, web_css_1.default)(makeMyClasses);
    const repLabel = (0, react_1.useMemo)(() => (0, calcRepetitionLabels_1.default)(schedule), [schedule]);
    const handleChangeRepetitionType = (0, react_1.useCallback)(newRT => {
        if (newRT === 'newcustom')
            return setShowCustom(true);
        onChange({ repetitionType: newRT });
    }, [onChange]);
    const handleChangeCustom = (0, react_1.useCallback)(newCR => {
        onChange({ customRepetition: newCR, repetitionType: RepetitionType_1.default.CUSTOM });
        setShowCustom(false);
    }, [onChange]);
    const handleCloseCustom = (0, react_1.useCallback)(() => setShowCustom(false), []);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Select_1.default, { classes: { root: myCss.selectRoot }, fullWidth: true, value: repetitionType, onChange: handleChangeRepetitionType },
            Object.values(RepetitionType_1.default)
                .filter(r => r !== RepetitionType_1.default.CUSTOM)
                .map(r => (react_1.default.createElement(MenuItem_1.default, { key: r, value: r }, repLabel[r]))),
            isCustom && (react_1.default.createElement(MenuItem_1.default, { classes: { root: myCss.customMenu }, value: RepetitionType_1.default.CUSTOM }, repLabel[RepetitionType_1.default.CUSTOM])),
            react_1.default.createElement(MenuItem_1.default, { value: "newcustom" }, lib_i18n_1.default.t('custom'))),
        showCustom && (react_1.default.createElement(CustomRepetitionDialog_1.default, { open: true, onChange: handleChangeCustom, onClose: handleCloseCustom, dueDate: dueDate, customRepetition: customRepetition }))));
};
exports.RepetitionTypePicker = RepetitionTypePicker;
exports.default = exports.RepetitionTypePicker;
